import React from "react";
import { FaSpinner } from "react-icons/fa";
import { ChatFrameProps } from "./types";

const ChatFrame: React.FC<ChatFrameProps> = ({ isLoading, onLoad }) => (
  <div className="relative flex-1">
    {isLoading && (
      <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50">
        <FaSpinner className="animate-spin text-2xl text-secondary" />
      </div>
    )}
    <iframe
      src="https://interfaces.zapier.com/embed/chatbot/cma2c0d33000avv2eer5j9hob"
      className="w-full h-full"
      allow="clipboard-write *"
      style={{ border: "none" }}
      onLoad={onLoad}
    />
  </div>
);

export default ChatFrame;
